module.exports = __webpack_public_path__ + "3d5190a8b898285880543227612bb1f6.mp4";